import { ServiceOffer } from "../common/const";
import { apiRequest } from "./common";

const getDashBoardDetails = async (type, studentId) => {
    const response = await apiRequest('get', `/test/dashboard/${type}/${studentId}`);
    return response.data;
};

const saveTestScore = async (data) => {
    const response = await apiRequest('post', `/test/score`, data);
    return response.data;
};

const getDashboardGraph = async (type, studentId) => {
    const response = await apiRequest('get', `/test/graph/${type}/${studentId}`);
    return response.data;
};

const createTestGoal = async (data) => {
    const response = await apiRequest('post', `/student-test-goal`, data);
    return response.data;
};

const getStudentTestGoal = async (type, studentId) => {
    const response = await apiRequest('get', `/student-test-goal/${type}/${studentId}`);
    return response.data;
};

const getResources = async (type, studentId,subService) => {
    const response = await apiRequest('get', `/resource?type=${type}&studentId=${studentId}${subService ? `&studentSubjectId=${subService}` : ''}`);
    return response.data;
};

const getTasks = async (type, studentId, subService) => {
    const response = await apiRequest('get', `/task?type=${type}&studentId=${studentId}${subService  ? type === 'PROJECT_MENTORING' ? `&projectId=${subService}`: `&studentSubjectId=${subService}` : ''}`);
    return response.data;
};

const getCounsellingTasks = async (type, studentId, status) => {
    const response = await apiRequest('get', `/task?type=${type}&studentId=${studentId}&status=${status}`);
    return response.data;
};


const UpdateTask = async (taskId, data) => {
    const response = await apiRequest('put', `/task/${taskId}`, data);
    return response.data;
};

const CreateTask = async (data) => {
    const response = await apiRequest('post', `/task`, data);
    return response.data;
};

const CreateResource = async (data) => {
    const response = await apiRequest('post', `/resource`, data);
    return response.data;
};

const DeleteTask = async (taskId) => {
    const response = await apiRequest('delete', `/task/${taskId}`);
    return response.data;
};


export {
    getDashBoardDetails,
    saveTestScore,
    getDashboardGraph,
    createTestGoal,
    getStudentTestGoal,
    getResources,
    getTasks,
    UpdateTask,
    CreateTask,
    CreateResource,
    getCounsellingTasks,
    DeleteTask
}